import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { SAVING_GET } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';


const api_get_project_dash = (data) => {

    let dataFrom = data.dataFrom;
    let dataTo = data.dataTo;

    delete data['date'];
    delete data['dataFrom'];
    delete data['dataTo'];

    var queryString = Object.keys(data).map(key => key + '=' + data[key]).join('&');

    return (dispatch, getState) => {
        Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };


            return axios.get(`${Config.API_BASE_URL}/AssetSaving/client/asset/${dataFrom}/${dataTo}?${queryString}`, config)
                .then(response => {
                    dispatch({
                        type: SAVING_GET,

                        payload: {
                            dataSaving: response.data,
                            errors: {},
                        }
                    })
                })
                .catch(error => {
                    dispatch({
                        type: SAVING_GET,
                        payload: {
                            errors: {},
                            task: {
                                result: false
                            }
                        }
                    })
                });
        }).catch(error => {
            // dispatch({ type: EXPIRED });
        });
    };
}

export default api_get_project_dash;
